import React from 'react';
import { TeamOutlined, SearchOutlined, ThunderboltOutlined, RocketOutlined } from '@ant-design/icons';
import { message } from 'antd';

const platforms = [
  {
    id: 'meta',
    icon: <TeamOutlined />,
    title: 'Meta Ads',
    description: 'Facebook & Instagram ads reaching billions of users',
  },
  {
    id: 'google',
    icon: <SearchOutlined />,
    title: 'Google Ads',
    description: 'Search, Display & Performance Max campaigns',
  },
  {
    id: 'both',
    icon: <ThunderboltOutlined />,
    title: 'Both Platforms',
    description: 'Maximize reach across Meta and Google',
  },
];

const ChooseAdPlatform = ({ selectedPlatform, onUpdate, onNext }) => {
  const handleSelect = (platformId) => {
    onUpdate(platformId);
  };

  const handleContinue = () => {
    if (!selectedPlatform) {
      message.warning('Please select an ad platform first');
      return;
    }
    
    // Proceed to next step (ConfigureMetaAds or ConfigureGoogleAds)
    onNext();
  };

  return (
    <div className="step-container">
      <h1 className="step-title">Choose Your Ad Platform</h1>
      <p className="step-subtitle">Select where you want to run your campaign</p>

      <div className="platform-grid">
        {platforms.map((platform) => (
          <div
            key={platform.id}
            className={`platform-card ${selectedPlatform === platform.id ? 'selected' : ''}`}
            onClick={() => handleSelect(platform.id)}
          >
            <div className="platform-icon">
              {platform.icon}
            </div>
            <div className="platform-title">{platform.title}</div>
            <p className="platform-description">{platform.description}</p>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="campaign-footer">
        <div className="footer-info"></div>
        <button 
          className="launch-btn" 
          onClick={handleContinue}
        >
          <RocketOutlined />
          Continue to Configuration
        </button>
      </div>
    </div>
  );
};

export default ChooseAdPlatform;
